import React, { useState } from "react";
import { db, storage } from "../firebase";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./Upload.css";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
function Upload({ user }) {
  const [caption, setCaption] = useState("");
  const [image, setImage] = useState(null);
  const [fileName, setFileName] = useState("");
  const [progress, setProgress] = useState(0);
  const [file, setFile] = useState(null);
  const [showDelete, setshowDelete] = useState(false);
  const [onlyTextPost, setonlyTextPost] = useState(true);


  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setonlyTextPost(false);
    }
    setFile(URL.createObjectURL(e.target.files[0]));

    var a = e.target.value.toString().split("\\");
    var name = a[a.length - 1];
    if (name.length > 20)
      name =
        name.split(".")[0].substring(0, 20) +
        "...." +
        name.split(".")[name.split(".").length - 1];
    setFileName(name);
    setshowDelete(true);
  };

  const handleTrash = () => {
    setonlyTextPost(true);
    setshowDelete(false);
    setImage(null);
    setFileName("");
    setFile(null);
  };

  const closeUpload = () => {
    document.querySelector(".upload").style.display = "none";
    document.querySelector(".filter").style.display = "none";
  };

  const openUpload = () => {
    document.querySelector(".upload").style.display = "grid";
    document.querySelector(".filter").style.display = "block";
  };
  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const handleUpload = () => {
    if (onlyTextPost) {
      var postId = makeid(13);
      setProgress(87);
      db.collection("PendingPosts")
        .doc(postId)
        .set({
          timestamp: String(new Date().getTime()),
          userId: user.id,
          name: user.name,
          userimage: user.iamge,
          description: caption,
          image_count: 0,
          postId: postId,
          liked_count: 0,
          comment_count: 0,
          tag: "General",
          institute: "",
          dept: "Published from tarok.tech",
          username: user.name
        });
      setProgress(0);
      setCaption("");
      setImage(null);
      setFileName("");
      setFile(null);
      setshowDelete(false);
      closeUpload();
      document
        .getElementById("root")
        .scrollIntoView({ behavior: "smooth" });
    } else {
      const imageName = `${image.name}${
        Math.floor(Math.random() * (9999 - 1000)) + 1000
      }`;
      const uploadTask = storage.ref(`post_images/${imageName}`).put(image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setProgress(progress);
        },

        (error) => {
          console.log(error);
          alert(error.message);
        }, () => {
          storage
            .ref("post_images")
            .child(imageName)
            .getDownloadURL()
            .then((url) => {
              var postId = makeid(13);
              db.collection("PendingPosts")
                .doc(postId)
                .set({
                  timestamp: String(new Date().getTime()),
                  userId: user.id,
                  name: user.name,
                  userimage: user.iamge,
                  description: caption,
                  image_count: 1,
                  image_url_0: url,
                  postId: postId,
                  liked_count: 0,
                  comment_count: 0,
                  tag: "General",
                  institute: "",
                  dept: "Published from tarok.tech",
                  username: user.name
                });
              setProgress(0);
              setCaption("");
              setImage(null);
              setFileName("");
              setFile(null);
              setshowDelete(false);
              closeUpload();
              document
                .getElementById("root")
                .scrollIntoView({ behavior: "smooth" });
            });
        }
      );
    }
  };

  return (
    <>
      <div className="addPostBtn" onClick={openUpload}>
        <AddCircleOutlineRoundedIcon />
      </div>
      <div className="upload">
        <div className="uploadContent">
          <h3 className="uploadPreview">Add Post</h3>
          {file && (
            <>
              <div className="postHeader"></div>
              <img className="postImage" src={file} alt={fileName} />
            </>
          )}
          <ReactQuill
            className="text"
            theme="snow"
            value={caption}
            onChange={setCaption}
          />
          <div className="uploadButtons">
            <label htmlFor="file-upload" className="customFileUpload">
              <AddPhotoAlternateOutlinedIcon fontSize="small" />{" "}
              <div className="bu">Add a Photo</div>
            </label>
            <input
              id="file-upload"
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
            {showDelete && (
              <>
                <div className="fileName">{fileName}</div>
                <div className="trashBtn" onClick={handleTrash}>
                  <HighlightOffRoundedIcon color="secondary" />
                </div>
              </>
            )}
          </div>
          <progress
            className="uploadProgress"
            value={progress}
            max="100"
          ></progress>
          <button
            type="submit"
            disabled={!caption}
            onClick={handleUpload}
            className="postButton"
          >
            Post
          </button>
          <div className="closeBtn" onClick={closeUpload}>
            <CancelRoundedIcon color="secondary" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Upload;
